import * as React from "react";
import { PriceViewGridBase } from "./styles";
import { ProductCurrencyPrice } from "utils/playground/product";

interface PriceViewsProps extends ProductCurrencyPrice {
	price: string;
	originPrice?: string;
	className?: string;
	isFlash?: boolean;
}

export const PriceViews = (props: PriceViewsProps) => {
	const {
		price,
		originPrice,
		className = "",
		isFlash,
		originPriceBr,
		priceCurrency,
		originPriceCurrency,
		priceSymbol,
		originPriceSymbol,
	} = props;
	return (
		<PriceViewGridBase key={"PriceViews"} className={className} isFlash={isFlash}>
			{price && (
				<span className={"currentPrice"}>
					{priceCurrency ? `${priceCurrency} ` : ""}
					{priceSymbol}
					{price}
				</span>
			)}
			{originPriceBr && <br />}
			{price !== originPrice && (
				<span className={"originPrice"}>
					{originPriceCurrency ? `${originPriceCurrency} ` : ""}
					{originPriceSymbol}
					{originPrice}
				</span>
			)}
		</PriceViewGridBase>
	);
};
